export default __webpack_public_path__ + "static/icon-clinical-blue-157279c0dbff03ebca627e1ab9a5edfb.png";